import * as React from "react"

const MOBILE_BREAKPOINT = 1024

// Pre-compute initial value to avoid flash - this runs synchronously before first render
const getInitialMobileState = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < MOBILE_BREAKPOINT;
};

// Cache the initial value to ensure consistency across all hook instances
const initialMobileState = getInitialMobileState();

export function useIsMobile() {
  // Initialize with cached value to prevent flash
  const [isMobile, setIsMobile] = React.useState<boolean>(initialMobileState);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    // Only update if different from current state to prevent re-render
    const currentValue = window.innerWidth < MOBILE_BREAKPOINT;
    if (currentValue !== isMobile) {
      setIsMobile(currentValue);
    }
    
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, []) // Remove isMobile from deps to prevent loops

  return isMobile
}
